import React, { useState, useEffect } from 'react';
import { FiUserPlus, FiUserCheck, FiBell } from 'react-icons/fi';
import api from '../../services/api';

const FollowStoreButton = ({ storeId, size = 'md' }) => {
  const [following, setFollowing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(0);

  useEffect(() => {
    const check = async () => {
      try {
        const [followRes, countRes] = await Promise.all([
          api.get(`/store-follow/check/${storeId}`).catch(() => ({ data: { isFollowing: false } })),
          api.get(`/store-follow/followers/${storeId}`),
        ]);
        setFollowing(followRes.data.isFollowing);
        setCount(countRes.data.count);
      } catch { /* not logged in */ }
      setLoading(false);
    };
    if (storeId) check();
  }, [storeId]);

  const toggle = async () => {
    try {
      if (following) {
        await api.delete(`/store-follow/${storeId}`);
        setFollowing(false);
        setCount(c => Math.max(0, c - 1));
      } else {
        await api.post(`/store-follow/${storeId}`);
        setFollowing(true);
        setCount(c => c + 1);
      }
    } catch { /* not logged in */ }
  };

  if (loading) return null;

  const isSmall = size === 'sm';

  return (
    <button
      onClick={toggle}
      className={`btn btn-${following ? '' : 'outline-'}${following ? 'success' : 'primary'} ${isSmall ? 'btn-sm' : ''}`}
      style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', fontWeight: 600, fontSize: isSmall ? '12px' : '14px' }}
    >
      {following ? <FiUserCheck size={isSmall ? 13 : 15} /> : <FiUserPlus size={isSmall ? 13 : 15} />}
      {following ? 'Following' : 'Follow'}
      {count > 0 && <span style={{ opacity: 0.7, fontSize: isSmall ? '10px' : '12px' }}>({count})</span>}
    </button>
  );
};

export default FollowStoreButton;
